<mat-card class="slidecontent">
  <div class="headcontent">
    <div class="pophead">
      <h3>Case Detail</h3>
      <button mat-icon-button (click)="closeCore(false)">
        <mat-icon class="close">close</mat-icon>
      </button>
    </div>
  </div>
  <div class="dialog_content">
    <mat-form-field appearance="">
      <mat-label>Case Name </mat-label>
      <input matInput value="Wound surgery along with infection" />
    </mat-form-field>

    <mat-form-field appearance="">
      <mat-label>importance</mat-label>
      <mat-select>
        <mat-option value="1">50%</mat-option>
        <mat-option value="2">100%</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="">
      <mat-label>Type</mat-label>
      <mat-select>
        <mat-option value="1">Checkup</mat-option>
        <mat-option value="2">Surgery</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="">
      <mat-label>Email</mat-label>
      <input matInput value="johan@gmail.com" />
    </mat-form-field>

    <mat-form-field appearance="">
      <mat-label>Phone</mat-label>
      <input matInput  value="98789878987" />
    </mat-form-field>

    <mat-form-field appearance="">
      <mat-label>Description</mat-label>
      <textarea matInput></textarea>
    </mat-form-field>
  </div>

  <div class="actionBtn">
    <button mat-flat-button class="calltoaction" type="submit" color="basic">
      Close
    </button>
    <button mat-flat-button class="calltoaction" type="submit" color="primary">
      Ok
    </button>
  </div>
</mat-card>

<div class="overlay" (click)="closeCore(false)"></div>
